module.exports = __webpack_public_path__ + "static/slide8-318x245-32a7bd85b8264d2754c33ed6c2f71771.gif";